document.addEventListener("turbolinks:load", function () {
  function initializeDropdownLogic() {
    const $button = $("#dropdownMenuButtonCatalog");
    const $dropdownMenu = $(".dropdown-main-menu");

    if ($button.data("initialized")) {
      return; // Логика уже была инициализирована
    }
    $button.data("initialized", true);

    // Закрытие меню при клике вне кнопки и меню
    $(document).on("click", function(event) {
      if (
        !$dropdownMenu.is(event.target) &&
        $dropdownMenu.has(event.target).length === 0 &&
        !$button.is(event.target) &&
        $button.has(event.target).length === 0
      ) {
        $dropdownMenu.removeClass("show");
      }
    });

    // Обработка клика по кнопке — открытие/закрытие меню
    $button.on("click", function(event) {
      console.log('$button');
      event.preventDefault();
      event.stopPropagation();
      $dropdownMenu.toggleClass("show");
    });
  }

  initializeDropdownLogic();
});